export class InputDate {
    public value: Date = new Date();
    public error: string = "";

}